import { render, staticRenderFns } from "./AssignedMilestoneUpdate.vue?vue&type=template&id=3ab6f052&"
import script from "./AssignedMilestoneUpdate.vue?vue&type=script&lang=js&"
export * from "./AssignedMilestoneUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports